<template lang="pug">
.page-new
	//- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(onclick='location.href='index-logged-in.html'')
	router-link.modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(to="/")
		.arrow-left
			i.fas.fa-chevron-left
		.modal-title.text-capitalize.pl-3 {{$t('ui.home')}}
	.page-wrap.w-100
		.page-history
			.statement-body
				.tab-statement
					ul#pills-tab.nav.nav-pills.mb-3.m-0.justify-content-between.align-items-center(role='tablist')
						li.nav-item.col-4.px-1(role='presentation' @click="changeTab(0)")
							a#pills-statement-tab.nav-link.text-uppercase(:class="{'active' : selectedTab == 0}" data-toggle='pill' href='#pills-statement' role='tab' aria-controls='pills-statement' aria-selected='true') statement
						li.nav-item.col-4.px-1(role='presentation' @click="changeTab(1)")
							a#pills-transaction-tab.nav-link.text-uppercase(:class="{'active' : selectedTab == 1}" data-toggle='pill' href='#pills-transaction' role='tab' aria-controls='pills-transaction' aria-selected='false') transaction history
						li.nav-item.col-4.px-1(role='presentation' @click="changeTab(2)")
							a#pills-bet-tab.nav-link.text-uppercase(:class="{'active' : selectedTab == 2}" data-toggle='pill' href='#pills-bet' role='tab' aria-controls='pills-bet' aria-selected='false') bet history
					//- .text-history You can view transaction history up to 90 days
					#pills-tabContent.tab-content
						dailyStatement(v-if="selectedTab==0" @showBet="showBet")
						transHistory(v-if="selectedTab==1")
						platformWinLose(v-if="selectedTab==2")
</template>
<script>
import dailyStatement from '@/component/statement/_dailyStatement.vue'
import transHistory from '@/component/statement/_transHistory.vue'
import platformWinLose from '@/component/statement/_platformWinLose.vue'
import _ from "lodash";
export default {
	components:{
		dailyStatement,
		transHistory,
		platformWinLose,
	},
	props:{
    target: {
      type: String,
      default: ""
    },
  },
	data(){
		return{
			selectedTab: 0,
			transNo: 0,
			showPlatformWinLose: false,
			showReport: false,
			platformData: [],
			category: "",
		}		
	},
	mounted(){
		window.scroll(0,0)
		if(this.target){ 
      // this.tabTarget = "transaction";
			this.selectedTab = 1
      $("#pills-transaction-tab").tab('show')
    }
	},
	methods:{
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		showBet(e){
			this.selectedTab = e
		},
		updateTrans(e){
			this.transNo = e
		},
		showBetHistory(e){
			this.showPlatformWinLose = true
			this.platformData = e.data
		},
		reportSelected(e){
			this.showReport = true
			switch(e){
				case 0:
					this.reportType = this.$t('ui.transfer')
					break;
				case 1:
					this.reportType = this.$t('ui.bonus_details')
					break;
				case 2:
					this.reportType = this.$t('ui.adjustment_details')
					break;
				case 3:
					this.reportType = this.$t('ui.referee')
				default:
					break;
			}
		},
		platformSelected(e){
			this.category = "> " + this.$t('ui.'+ e.toLowerCase())
		},
		clearReportType(){
			if(this.showReport === false && this.reportType === ""){
				return
			}else{
				this.showReport = false
				this.reportType = ""
				this.$refs.dailyStatement.reset()
			}
		},
		backToStatement(){
			if(this.showPlatformWinLose === false && this.category === ""){
				return
			}else{
				this.showPlatformWinLose = false
				this.category = ""
			}
		},
		clearCategory(){
			this.$refs.platformWinLose.reset()
			this.category = ""
		},
		reset(){
			this.category = ""
			this.reportType = ""
			this.showReport = false
			this.platformWinLose = false
		}
	}
}
</script>